
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import hisService from "services/admin/masters/hisService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import { MAPPING_SELECT_ERROR_TEMPLATE } from "constants/admin/masters/vmware";
import { ERROR_MESSAGE_UNKNOWN, MSG_RECORD_CREATE, MSG_RECORD_DELETE, MSG_RECORD_UNDO_DELETE, MSG_RECORD_UPDATE } from "constants/common";
import {getMatrixId} from "utils/matriceHelpers";
function ManageHisNic() {

  const [breamcrumbs, setBreamcrumbs] = useState([
    { title: "HIS Masters Mapping", url: "/admin/master/his/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new hisService();
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [nicList, setNicList] = useState([]);
  const [nicDriverList, setNicDriverList] = useState([]);
  const [mappingList, setMappingList] = useState([{}]);
  const [selectedCombineKeys, setSelectedCombineKeys] = useState([]);
  const [selectedNic, setSelectedNic] = useState(null);
  const [nicIoCardType, setNicIoCardType] = useState("");
  const [nicIds, setNicIds] = useState("");
  const [nicFootnotes, setNicFootnotes] = useState("");
  const [selectedNicDriver, setSelectedNicDriver] = useState(null);
  const [nicDriverType, setNicDriverType] = useState("");
  const [nicFirmware, setNicFirmware] = useState("");
  const [combineKeyError, setCombineKeyError] = useState("");
  const [selectedNicError, setSelectedNicError] = useState("");
  const [nicIoCardTypeError, setNicIoCardTypeError] = useState("");
  const [nicIdsError, setNicIdsError] = useState("");
  const [nicFootnotesError, setNicFootnotesError] = useState("");
  const [nicDriverError, setNicDriverError] = useState("");
  const [nicDriverTypeError, setNicDriverTypeError] = useState("");
  const [nicFirmwareError, setNicFirmwareError] = useState("");
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [itemToBeEdited, setItemToBeEdited] = useState(null);
  const [isDeleteConfirmationShown, setIsDeleteConfirmationShown] = useState(false);
  const [isRestoreConfirmationShown, setIsRestoreConfirmationShown] = useState(false);
  const [deleteConfirmationMessage, setDeleteConfirmationMessage] = useState("");
  const [restoreConfirmationMessage, setRestoreConfirmationMessage] = useState("");
  const [itemToBeDeletedOrRestored, setItemToBeDeletedOrRestored] = useState(null);

  const Id  = getMatrixId(window.location.pathname);

  useEffect(() => getMappingData(), []);

  useEffect(() => {
    // re-validate form upon field value change if form is touched
    if (isFormTouched) {
      validateMappingForm();
    }
  }, [selectedCombineKeys, selectedNic, nicIoCardType, nicIds, nicFootnotes,
    selectedNicDriver, nicDriverType, nicFirmware]);

  useEffect(() => {
    // populate details of item to be edited
    if (isEditMode) {
      populateItemDetailsToEdit();
    }
  }, [itemToBeEdited?.record_details?.id]);

  const getMappingData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        setMappingList(response?.his_nic_mapping_list);
        extractAndSetCombineKeys(response?.his_combine_keys);
        extractAndSetNic(response?.nic_master_drop_list);
        extractAndSetNicDriver(response?.nic_driver_master_drop_list);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };

  // setting Combine keys
  const extractAndSetCombineKeys = (dataList) => {
    const combineKeyList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    setCombineKeyList(combineKeyList);
  };

  // setting nic list
  const extractAndSetNic = (dataList) => {
    const nicList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setNicList(nicList);
  };

  // setting nic driver
  const extractAndSetNicDriver = (dataList) => {
    const nicDriverList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setNicDriverList(nicDriverList);
  };

  // reset form values, error messages, form state, edit mode, target edit item
  const resetForm = () => {
    resetFormValues();
    resetErrorMessages();
    setIsFormTouched(false);
    setIsEditMode(false);
    setItemToBeEdited(null);
  };

  // append offending field name in error message
  const getSelectErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };

  // validate fields and set or reset error message
  const validateMappingForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getSelectErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }

    if (!selectedNic) {
      setSelectedNicError(getSelectErrorMessageFor("NIC"));
      isFormValid = false;
    } else {
      setSelectedNicError("");
    }

    if (!selectedNicDriver) {
      setNicDriverError(getSelectErrorMessageFor("NIC Driver"));
    } else {
      setNicDriverError("");
    }

    return isFormValid;
  };

  // reset field values
  const resetFormValues = () => {
    setSelectedCombineKeys([]);
    setSelectedNic(null);
    setNicIoCardType("");
    setNicIds("");
    setNicFootnotes("");
    setSelectedNicDriver(null);
    setNicDriverType("");
    setNicFirmware("");
  };

  // reset error messages
  const resetErrorMessages = () => {
    setCombineKeyError("");
    setSelectedNicError("");
    setNicIoCardTypeError("");
    setNicIdsError("");
    setNicFootnotesError("");
    setNicDriverError("");
    setNicDriverTypeError("");
    setNicFirmwareError("");
  };

  // api call for adding new mapping
  const addMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();

    // call POST api if form is valid
    if (isFormValid) {
      let payload = {
        nic_id: selectedNic?.id,
        nic_io_card_type: nicIoCardType,
        nic_ids: nicIds,
        nic_footnotes: nicFootnotes,
        nic_driver_id: selectedNicDriver?.id,
        nic_driver_type: nicDriverType,
        nic_firmware: nicFirmware,
        his_combine_keys: selectedCombineKeys?.map(key => key?.id)
      };
      serviceObj.createNicMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getMappingData();
        resetForm();
      });
    }
  };

  // process target item for editing
  const populateItemDetailsToEdit = () => {
    const combineKeysToEdit = itemToBeEdited?.his_combine_keys?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    const nicToEdit = {
      id: itemToBeEdited?.record_details?.nic_id,
      value: itemToBeEdited?.record_details?.nic,
      label: itemToBeEdited?.record_details?.nic
    };
    const nicDriverToEdit = {
      id: itemToBeEdited?.record_details?.nic_driver_id,
      value: itemToBeEdited?.record_details?.nic_driver,
      label: itemToBeEdited?.record_details?.nic_driver
    };
    setSelectedCombineKeys(combineKeysToEdit);
    setSelectedNic(nicToEdit);
    setNicIoCardType(itemToBeEdited?.record_details?.nic_io_card_type);
    setNicIds(itemToBeEdited?.record_details?.nic_ids);
    setNicFootnotes(itemToBeEdited?.record_details?.nic_footnotes);
    setSelectedNicDriver(nicDriverToEdit);
    setNicDriverType(itemToBeEdited?.record_details?.nic_driver_type);
    setNicFirmware(itemToBeEdited?.record_details?.nic_firmware);
    setNicFirmware(itemToBeEdited?.record_details?.nic_firmware);
  };

  // fetch details of item to be edited
  const editMapping = (data) => {
    setIsEditMode(true);
    // fetch details of item to edit
    serviceObj.getNicMappingDetails(data?.id).then((response) => {
      setItemToBeEdited(response);
    })
      .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN));
  };

  // update 
  const updateMappingById = (e) => {
    console.log("update")
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();
    if (isFormValid) {
      const payload = {
        nic_id: selectedNic?.id,
        nic_io_card_type: nicIoCardType,
        nic_ids: nicIds,
        nic_footnotes: nicFootnotes,
        nic_driver_id: selectedNicDriver?.id,
        nic_driver_type: nicDriverType,
        nic_firmware: nicFirmware,
        his_combine_keys: selectedCombineKeys?.map(key => key?.id)
      };
      const targetItemId = itemToBeEdited?.record_details?.id;
      serviceObj.updateNicMappingById(targetItemId, payload).then((response) => {
        toast.success(MSG_RECORD_UPDATE);
        getMappingData();
        resetForm();
      })
        .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN)
        );
    }
  };

  // delete or restore mapping
  const deleteOrRestoreMappingById = () => {
    const { id, is_deleted } = itemToBeDeletedOrRestored;
    serviceObj.deleteNicMappingById(id)
      .then((response) => {
        // show deleted or restored message based on is_deleted property
        if (is_deleted) {
          toast.success(MSG_RECORD_UNDO_DELETE);
          setIsRestoreConfirmationShown(false);
          setRestoreConfirmationMessage("")
        } else {
          toast.success(MSG_RECORD_DELETE);
          setIsDeleteConfirmationShown(false)
          setDeleteConfirmationMessage("");
        }
        resetForm();
        setItemToBeDeletedOrRestored(null);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setIsDeleteConfirmationShown(false)
        setDeleteConfirmationMessage("");
        setItemToBeDeletedOrRestored(null);
      })
      .finally(() => getMappingData());
  };

  // show delete warning confirmation popup
  const deleteMappingHandler = (rowData) => {
    setIsDeleteConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setDeleteConfirmationMessage(`Are you sure you want to remove ${rowData?.nic} with Combine Key ${rowData?.his_combine_key}?`)
  };

  // show restore warning confirmation popup
  const restoreMappingHandler = (rowData) => {
    setIsRestoreConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setRestoreConfirmationMessage(`Are you sure you want to restore ${rowData?.nic} with Combine Key ${rowData?.his_combine_key}?`);
  };

  // hide confirmation message and reset target item
  const cancelDeleteItem = () => {
    setIsDeleteConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
  };

  // hide confirmation message and reset target item
  const cancelRestoreItem = () => {
    setIsRestoreConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
    setRestoreConfirmationMessage("")
  };

  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breamcrumbs} disableEditTitle={true} />
      {isDeleteConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelDeleteItem}
        >
          {deleteConfirmationMessage}
        </ConfirmBox>
      }
      {isRestoreConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelRestoreItem}
        >
          {restoreConfirmationMessage}
        </ConfirmBox>
      }
      <div className="form-group d-flex">
        <div className="col-sm-4">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                {/* Combine key */}
                <div className="form-group">
                  <label htmlFor={"combineKey"} className="mr-sm-2 mt-2"><b>HIS Combine Key</b></label>
                  {/* add multi select dropdown */}
                  <Select
                    isMulti
                    id="combineKey"
                    name="Combine Key"
                    options={combineKeyList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedCombineKeys(selectedKeys)}
                    value={selectedCombineKeys}
                    isOptionDisabled={option => option.disabled}
                  />
                  {
                    combineKeyError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{combineKeyError}</div>
                  }
                </div>
                {/* nic */}
                <div className="form-group">
                  <label htmlFor={"nic"} className="mr-sm-2"><b>NIC</b></label>
                  <Select
                    name="nic"
                    id="nic"
                    options={nicList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedNic(selectedKeys)}
                    value={selectedNic}
                    isOptionDisabled={option => option.disabled}
                    isDisabled={isEditMode}
                  />
                  {selectedNicError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{selectedNicError}</div>
                  }
                </div>
                {/* nic io card type */}
                <div className="form-group">
                  <label htmlFor={"nicIoCardType"} className="mr-sm-2"><b>NIC IO Card Type</b></label>
                  <input type="text"
                    id="nicIoCardType"
                    className="form-control"
                    maxLength="60"
                    name="nicIoCardType"
                    value={nicIoCardType}
                    onChange={(e) => setNicIoCardType(e.target.value)}
                    placeholder="Enter NIC IO Card Type"
                  />
                  {nicIoCardTypeError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{nicIoCardTypeError}</div>
                  }
                </div>
                {/* nic ids */}
                <div className="form-group">
                  <label htmlFor={"nicIds"} className="mr-sm-2"><b>NIC IDs (VID, DVID, SVID, SSID)</b></label>
                  <input type="text"
                    id="nicIds"
                    className="form-control"
                    maxLength="60"
                    name="nicIds"
                    value={nicIds}
                    onChange={(e) => setNicIds(e.target.value)}
                    placeholder="Enter NIC IDs"
                  />
                  {nicIdsError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{nicIdsError}</div>
                  }
                </div>
                {/* nic footnotes */}
                <div className="form-group">
                  <label htmlFor={"nicFootnotes"} className="mr-sm-2"><b>NIC Footnotes</b></label>
                  <input type="text"
                    id="nicFootnotes"
                    className="form-control"
                    maxLength="60"
                    name="nicFootnotes"
                    value={nicFootnotes}
                    onChange={(e) => setNicFootnotes(e.target.value)}
                    placeholder="Enter NIC Footnotes"
                  />
                  {nicFootnotesError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{nicFootnotesError}</div>
                  }
                </div>
                {/* nic driver*/}
                <div className="form-group">
                  <label htmlFor={"nicDriver"} className="mr-sm-2"><b>NIC Driver</b></label>
                  <Select
                    name="nicDriver"
                    id="nicDriver"
                    options={nicDriverList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedNicDriver(selectedKeys)}
                    value={selectedNicDriver}
                    isOptionDisabled={option => option.disabled}
                  />
                  {nicDriverError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{nicDriverError}</div>
                  }
                </div>
                {/* nic driver type */}
                <div className="form-group">
                  <label htmlFor={"nicDriverType"} className="mr-sm-2"><b>NIC Driver Type</b></label>
                  <input type="text"
                    id="nicDriverType"
                    className="form-control"
                    maxLength="60"
                    name="nicDriverType"
                    value={nicDriverType}
                    onChange={(e) => setNicDriverType(e.target.value)}
                    placeholder="Enter NIC Driver Type"
                  />
                  {nicIoCardTypeError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{nicDriverTypeError}</div>
                  }
                </div>
                {/* nic firmware */}
                <div className="form-group">
                  <label htmlFor={"nicFirmware"} className="mr-sm-2"><b>NIC Firmware</b></label>
                  <input type="text"
                    id="nicFirmware"
                    className="form-control"
                    maxLength="60"
                    name="nicFirmware"
                    value={nicFirmware}
                    onChange={(e) => setNicFirmware(e.target.value)}
                    placeholder="Enter NIC Firmware"
                  />
                  {nicFirmwareError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{nicFirmwareError}</div>
                  }
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <button type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2">
                <i className="fa fa-refresh"></i> Reset</button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                onClick={isEditMode ? updateMappingById : addMapping}
              >
                {isEditMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-8">
          <MaterialTable
            title="NIC Mappings"
            columns={[
              { title: "Combine Key", field: "his_combine_key" },
              { title: "NIC", field: "nic" },
              { title: "NIC IO Card Type", field: "nic_io_card_type" },
              { title: "NIC IDs", field: "nic_ids" },
              { title: "NIC Footnotes", field: "nic_footnotes" },
              { title: "NIC Driver", field: "nic_driver" },
              { title: "NIC Driver Type", field: "nic_driver_type" },
              { title: "NIC Firmware", field: "nic_firmware" }
            ]}
            data={mappingList}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400
            }}

            localization={{
              header: {
                actions: "Actions",
              },
            }}
            actions={
              [
                (rowData) => ({
                  icon: "edit",
                  tooltip: !rowData.is_deleted && "Edit Record",
                  onClick: (e, data) => editMapping(data),
                  hidden: !rowData?.id || rowData.is_deleted // display action only if any valid item is present
                }),
                (rowData) => ({
                  icon: rowData.is_deleted ? "undo" : "delete",
                  tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                  onClick: (e, data) => rowData.is_deleted ? restoreMappingHandler(data) : deleteMappingHandler(data),
                  hidden: !rowData?.id // display action only if any valid item is present
                })
              ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageHisNic;